import api from '../../../config/api';

// eslint-disable-next-line import/prefer-default-export
export const ActivityService = {
	async getActivitiesList(activeFiltre) {
		const result = await api
			.get(
				`${process.env.REACT_APP_API_ENDPOINT}api/activities/${activeFiltre}`,
			)
			.then((response) => response)
			.catch((err) => ({
				status: err.response.status,
				data: null,
			}));

		return result;
	},
	async updateActivityStatus(nuint, readStatus, processStatus) {
		const data = {
			nuint,
			readStatus,
			processStatus,
		};

		const result = api
			.post(
				`${process.env.REACT_APP_API_ENDPOINT}api/activities/update/${nuint}`,
				data,
			)
			.then((response) => response)
			.catch((err) => ({
				status: err.response.status,
				data: null,
			}));

		return result;
	},

	async getDocumentContent(token) {
		const result = await api
			.get(`${process.env.REACT_APP_API_ENDPOINT}api/documents/${token}`)
			.then((response) => response)
			.catch((err) => ({
				status: err.response.status,
				data: null,
			}));

		return result;
	},

	async uploadDocument(params) {
		const result = api
			.post(`${process.env.REACT_APP_API_ENDPOINT}api/documents`, params)
			.then((response) => response)
			.catch((err) => ({
				status: err.response.status,
				data: null,
			}));

		return result;
	},

	async confirmationSendDocument(params) {
		const result = api
			.post(
				`${process.env.REACT_APP_API_ENDPOINT}api/confirmationSend`,
				params,
			)
			.then((response) => response)
			.catch((err) => ({
				status: err.response.status,
				data: null,
			}));

		return result;
	},

	async addComment(nuint, comment, sendComment) {
		try {
			const data = {
				nuint,
				comment,
				sendComment,
			};
			const res = await api
				.post(
					`${process.env.REACT_APP_API_ENDPOINT}api/activities/update/${nuint}`,
					data,
				)
				.then((response) => response)
				.catch((err) => ({
					status: err.response.status,
					data: null,
				}));

			return res;
		} catch (e) {
			return {
				status: 500,
				data: null,
			};
		}
	},
};
